import { render, staticRenderFns } from "./inquiry-comments.vue?vue&type=template&id=0e90f5c6&scoped=true"
import script from "./inquiry-comments.vue?vue&type=script&lang=ts"
export * from "./inquiry-comments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e90f5c6",
  null
  
)

export default component.exports